import React, { useState, useRef, useEffect } from "react";
import API from "../api";
import { useNavigate } from "react-router-dom";
import style from "./loginForm.module.scss";
import { antdMessageError } from "../utils/antdMessageComponent";
import { storage, SUB_DOMAIN_TYPE } from "../utils/storage";
import LogoSvg from "../assests/logo.svg";
import LogoPng from "../assests/logo_2.png";
const LoginForm = ({
  isAdmin,
  isPatner,
}: {
  isAdmin?: boolean;
  isPatner?: boolean;
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const buttonRef = useRef<HTMLDivElement | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    buttonRef?.current?.focus();
  }, []);
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && buttonRef.current && email && password) {
      buttonRef?.current?.click();
    }
  };
  const onFinish = async ({
    email,
    password,
  }: {
    email: string;
    password: string;
  }) => {
    try {
      if (isAdmin) {
        const loginResponse = await API.auth.AdminLogin({ email, password });

        if (!API.validators.checkSuccessCode(loginResponse))
          return antdMessageError("Invalid Credentials");

        const loginResponseData = loginResponse.data.data as {
          token: string;
          sessionId: string;
          expiresAt: string;
          version: number;
          userName: string;
        };
        storage.setAuthDetails({
          userType: SUB_DOMAIN_TYPE.ADMIN,
          token: loginResponseData.token,
          expiresAt: loginResponseData.expiresAt,
          version: loginResponseData.version,
          sessionId: loginResponseData.sessionId,
          userName: loginResponseData.userName,
        });
        navigate("/admin/dashboard/schedule");
      }
      if (isPatner) {
        const loginResponse = await API.auth.PartnerLogin({ email, password });
        if (!API.validators.checkSuccessCode(loginResponse))
          return antdMessageError("Invalid Credentials");

        const loginResponseData = loginResponse.data.data as {
          token: string;
          sessionId: string;
          expiresAt: string;
          version: number;
          partnerDetails: { username: string; _id: string };
        };
        storage.setAuthDetails({
          userType: SUB_DOMAIN_TYPE.PARTNER,
          token: loginResponseData.token,
          expiresAt: loginResponseData.expiresAt,
          version: loginResponseData.version,
          sessionId: loginResponseData.sessionId,
          userName: loginResponseData.partnerDetails.username,
          _id: loginResponseData.partnerDetails._id,
        });
        navigate("/partner/dashboard/schedule");
      }
    } catch (error: any) {
      console.error("Login error:", error);
      if (error.message === "Network Error" || error.code === "ERR_NETWORK") {
        antdMessageError(
          "Network Error: Unable to connect to the server. Please check if the API server is running and REACT_APP_API_URL is configured correctly."
        );
      } else {
        antdMessageError(
          error.message || "An error occurred during login. Please try again."
        );
      }
    }
  };
  return (
    <>
      <div className={style["container"]}>
        <div className={style["glass-form"]}>
          <div className={style["logo-container"]}>
            <img src={LogoSvg} alt="Logo" className={style["logo"]} />
            <img src={LogoPng} alt="Logo" className={style["logo-mobile"]} />
          </div>
          {isAdmin && (
            <h1 className={style["heading"]}>Admin Login Page</h1>
          )}
          <div className={style["wrap-form"]}>
            <label htmlFor="name" className={style["form-label"]}>
              User Name:
            </label>
            <input
              type="text"
              id="name"
              name="name"
              className={style["form-input"]}
              required
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={handleKeyPress}
            />

            <label htmlFor="password" className={style["form-label"]}>
              Password:
            </label>
            <input
              type="password"
              id="password"
              name="password"
              className={style["form-input"]}
              required
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyPress}
            />

            <div
              className={style["form-button"]}
              onClick={() => onFinish({ email: email, password: password })}
              ref={buttonRef}
            >
              Login
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LoginForm;
